import { render, staticRenderFns } from "./platformImageRuleConfig.vue?vue&type=template&id=5eb92634&scoped=true&"
import script from "./platformImageRuleConfig.vue?vue&type=script&lang=js&"
export * from "./platformImageRuleConfig.vue?vue&type=script&lang=js&"
import style0 from "./platformImageRuleConfig.vue?vue&type=style&index=0&id=5eb92634&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5eb92634",
  null
  
)

export default component.exports